import { Injectable } from '@angular/core';
import { ISchedule } from '../interfaces/schedule';
import { AngularFirestore } from '@angular/fire/firestore';


@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  constructor(private firestore: AngularFirestore) { }

  AddMessage(schedule: ISchedule) {
    return this.firestore.collection("messages").add(schedule);
  }

}
